import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VeeValidate, { Validator } from 'vee-validate'
import VeeI18nValidate from './i18n/vee-validate'
import VeeAuthorizeValidate from './rules/vee-validate/authorize'
import VueResource from 'vue-resource'
import VueCalendar from 'vue2-simple-calendar'

import AppModal from './plugins/AppModal'
import AppModalAsync from './plugins/AppModalAsync'
import AppToast from './plugins/AppToast'

import Moment from 'moment'

import * as VueSvgIcon from 'vue-svgicon'

import Middleware from '@/middleware'
import Router from '@/router'
import Store from '@/store'
import Filters from '@/utils/filters'

import ApiModule from '@/api'
import ConsoleLog from '@/utils/consolelog'
import DocumentTitle from '@/utils/title'
import Settings from '@/settings'

import ServiceWorker from '@/sw'
import I18nMessages from '@/i18n'
import Document from '@/utils/document'

import LayoutMainComponent from '@/components/layouts/LayoutMainComponent'
import LayoutMainForm from '@/components/layouts/LayoutMainForm'
import LayoutPageV2 from '@/components/layouts/LayoutPageV2'
import LayoutFormV2 from '@/components/layouts/LayoutFormV2'

import ErrorBox from '@/components/boxes/ErrorBox'
import ErrorPopUp from '@/components/boxes/ErrorPopUp'
import SuccessBox from '@/components/boxes/SuccessBox'
import FloatingBoxes from '@/components/boxes/FloatingBoxes'

import ModalBox from '@/components/modals/ModalBox'

//import CheckPermission from '@/components/permissions/CheckPermission'

import Shape from '@/components/shapes/Shape'
import ButtonIcon from '@/components/inputs/ButtonIcon'
import ButtonIconLoading from '@/components/inputs/ButtonIconLoading'
import ButtonIconOpen from '@/components/inputs/ButtonIconOpen'
import ButtonIconText from '@/components/inputs/ButtonIconText'
import ButtonNativeIconText from '@/components/inputs/ButtonNativeIconText'
import ButtonIconTextLoading from '@/components/inputs/ButtonIconTextLoading'
import ButtonLoading from '@/components/inputs/ButtonLoading'
import ButtonSubmit from '@/components/inputs/ButtonSubmit'
import ButtonSubmitIconText from '@/components/inputs/ButtonSubmitIconText'
import InputDate from '@/components/inputs/InputDate'
import InputDatePicker from '@/components/inputs/InputDatePicker'
import InputFloat from '@/components/inputs/InputFloat'
import InputPassword from '@/components/inputs/InputPassword'
import InputCheckbox from '@/components/inputs/InputCheckbox'
import InputRadio from '@/components/inputs/InputRadio'
import InputRadioV2 from '@/components/inputs/InputRadioV2'
import InputSelect from '@/components/inputs/InputSelect'
import InputSelectGrouped from '@/components/inputs/InputSelectGrouped'
import InputText from '@/components/inputs/InputText'
import InputRange from '@/components/inputs/InputRange'
import InputTextarea from '@/components/inputs/InputTextarea'
import InputTime from '@/components/inputs/InputTime'
import InputToggle from '@/components/inputs/InputToggle'
import Navigation from '@/components/navigation/Navigation'
import Spinner from 'vue-simple-spinner'
import wysiwyg from 'vue-wysiwyg'

import AvatarPictureUser from '@/components/avatars/AvatarPictureUser'
import AvatarPictureVirtualWatch from '@/components/avatars/AvatarPictureVirtualWatch'

import InstallPWA from '@/classes/InstallPWA'
import App from '@/App'

import '@/assets/scss/app.scss'
import '@/icons'
import 'vue-wysiwyg/dist/vueWysiwyg.css'

import { checkPermission as CheckPermissionDirective } from '@/directives/CheckPermission'
import { checkUserPermission as CheckUserPermissionDirective } from '@/directives/CheckPermission'
import { checkGroupPermission as CheckGroupPermissionDirective } from '@/directives/CheckPermission'
import { checkWatchPermission as CheckWatchPermissionDirective } from '@/directives/CheckPermission'

Vue.directive('check-permission', CheckPermissionDirective)
Vue.directive('check-user', CheckUserPermissionDirective)
Vue.directive('check-group', CheckGroupPermissionDirective)
Vue.directive('check-watch', CheckWatchPermissionDirective)

VeeValidate.Validator.extend('authorize', VeeAuthorizeValidate)

Vue.use(Filters)
Vue.use(ApiModule)
Vue.use(VueI18n)
Vue.use(VeeValidate, VeeI18nValidate)
Vue.use(VueResource)
Vue.use(VueSvgIcon)
Vue.use(VueCalendar, { showLimit: 999, fullDayNames: true, fullMonthNames: true })
Vue.use(wysiwyg, { hideModules: { "image": true }, forcePlainTextOnPaste: true })

Vue.use(AppModal)
Vue.use(AppModalAsync)
Vue.use(AppToast)

Vue.component('shape', Shape)
Vue.component('navigation', Navigation)
Vue.component('spinner', Spinner)
Vue.component('error-box', ErrorBox)
Vue.component('error-popup', ErrorPopUp)
Vue.component('success-box', SuccessBox)
Vue.component('floating-boxes', FloatingBoxes)
Vue.component('modal-box', ModalBox)
Vue.component('button-icon', ButtonIcon)
Vue.component('button-icon-loading', ButtonIconLoading)
Vue.component('button-icon-open', ButtonIconOpen)
Vue.component('button-icon-text', ButtonIconText)
Vue.component('button-native-icon-text', ButtonNativeIconText)
Vue.component('button-icon-text-loading', ButtonIconTextLoading)
Vue.component('button-loading', ButtonLoading)
Vue.component('button-submit', ButtonSubmit)
Vue.component('button-submit-icon-text', ButtonSubmitIconText)
Vue.component('input-date', InputDate)
Vue.component('input-date-picker', InputDatePicker)
Vue.component('input-float', InputFloat)
Vue.component('input-password', InputPassword)
Vue.component('input-checkbox', InputCheckbox)
Vue.component('input-radio', InputRadio)
Vue.component('input-radio-v2', InputRadioV2)
Vue.component('input-select', InputSelect)
Vue.component('input-select-grouped', InputSelectGrouped)
Vue.component('input-text', InputText)
Vue.component('input-range', InputRange)
Vue.component('input-textarea', InputTextarea)
Vue.component('input-time', InputTime)
Vue.component('input-toggle', InputToggle)
Vue.component('layout-main-component', LayoutMainComponent)
Vue.component('layout-main-form', LayoutMainForm)
Vue.component('layout-page-v2', LayoutPageV2)
Vue.component('layout-form-v2', LayoutFormV2)
Vue.component('avatar-picture-user', AvatarPictureUser)
Vue.component('avatar-picture-virtual-watch', AvatarPictureVirtualWatch)
//Vue.component('check-permission', CheckPermission)

Middleware(Router)

Vue.config.productionTip = false
// Vue.config.devtools = true
// Vue.config.performance = true

Vue.prototype.$log = ConsoleLog
Vue.prototype.$title = DocumentTitle
Vue.prototype.$moment = Moment
Vue.prototype.$document = Document

//Vue.prototype.$varInspector = []

//if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
	// Register service worker
	//ServiceWorker.register()
//}

ConsoleLog.info('translations', I18nMessages)()

// Create VueI18n instance with options
const i18n = new VueI18n({
	//locale: 'en-gb', // set locale (locale is setup on vue created)
	messages: I18nMessages, // set locale messages
})

new Vue({
	el: '#app',
	router : Router,
	store : Store,
	i18n,
	components: { App },
	template: '<App/>',
	data () {
		return {
			settings: Settings,
			online: false
		}
	},
	watch: {
		// Locale watcher
		'$i18n.locale' (value) {
			this.$validator.localize(value.split('-').shift())
			this.$document.lang.set(value)
			this.$moment.locale(value)
			this.$store.dispatch('setUserLocale', value)
			this.$log.info('locale', value)()
		}
	},
	created () {
		// Setup locale from storage
		const locale = this.$store.getters.getLocale || Settings.defaultLang
		this.$i18n.locale = locale
	},
	mounted () {
		// Register serviceworker
		if (this.$store.getters.isAuthenticated) {
			ServiceWorker.register(() => {
				ServiceWorker.setupClient(this)
			}, this)
		}
		// Check online/offline
		this.online = navigator.onLine
		const onlineHandler = () => {
			this.$emit('online')
			this.online = true
		}
		const offlineHandler = () => {
			this.$emit('offline')
			this.online = false
		}
		window.addEventListener('online', onlineHandler)
		window.addEventListener('offline', offlineHandler)
		this.$once('hook:destroyed', () => {
			window.removeEventListener('online', onlineHandler)
			window.removeEventListener('offline', offlineHandler)
		})

		const installPWA = new InstallPWA(this)
		installPWA.setup()
	}
})


// WEBPACK FOOTER //
// ./src/main.js